
// 保障权益
const bzqy = [{
    title: '人身意外伤害',
    planA: '成年人30万元;未成年人10万元',
    planB: '成年人50万元;未成年人10万元',
    planC: '成年人100万元;未成年人10万元'
}, {
    title: '医疗及相关费用',
    planA: '30万元',
    planB: '成年人40万元;未成年人30万元',
    planC: '成年人65万元;未成年人40万元'
}, {
    title: '回国后后续医药费用',
    planA: '6万元',
    planB: '6万元',
    planC: '6万元'
}, {
    title: '慰问及探访费用',
    planA: '1万元',
    planB: '1万元',
    planC: '2.5万元'
}, {
    title: '每日住院津贴收入',
    planA: '无',
    planB: '3,000元(RMB100/天 )',
    planC: '3,000元(RMB100/天 )'
}, {
    title: '24小时全球紧急救助服务（包括医疗运送和送返、身故遗体送返及丧葬费用）',
    planA: '100万元',
    planB: '100万元',
    planC: '100万元'
}, {
    title: '其中身故遗体送返及丧葬费用限额',
    planA: '30万元',
    planB: '30万元',
    planC: '30万元'
}, {
    title: '其中丧葬费用限额',
    planA: '1.6万元',
    planB: '1.6万元',
    planC: '1.6万元'
}, {
    title: '旅行行李延误 （每6小时延误赔偿额：RMB500 ）',
    planA: '无',
    planB: '1,000元',
    planC: '2,000元'
}, {
    title: '旅行延误 （每4小时延误赔偿额：RMB300）',
    planA: '无',
    planB: '900元',
    planC: '1,800元'
}, {
    title: '旅行变更',
    planA: '5,000元',
    planB: '1万元',
    planC: '1.5万元'
}, {
    title: '旅行者证件丢失',
    planA: '5,000元',
    planB: '8,000元',
    planC: '1万元'
}, {
    title: '旅行者信用卡盗刷（不适用于未成年人）',
    planA: '无',
    planB: '8,000元',
    planC: '8,000元'
}, {
    title: '旅行个人责任',
    planA: '30万元',
    planB: '50万元',
    planC: '80万元'
}, {
    title: '旅行家居财物保障 （每件/每套物品赔偿限额RMB1,000）',
    planA: '5,000元',
    planB: '5,000元',
    planC: '5,000元'
}, {
    title: '保障期间的自动延长',
    planA: '最长10天',
    planB: '最长10天',
    planC: '最长10天'
},]
const bzqyEn = [{
    title: 'Personal Accident',
    planA: 'Adult 300,000 Child(ren) 100,000',
    planB: 'Adult 500,000 Child(ren) 100,000',
    planC: 'Adult 1,000,000 Child(ren) 100,000'
}, {
    title: 'Medical and Related Expenses',
    planA: '300,000',
    planB: 'Adult 400,000, Child(ren) 300,000',
    planC: 'Adult 650,000, Child(ren) 400,000'
}, {
    title: 'Follow Up Medical Treatment in Mainland China',
    planA: '60,000',
    planB: '60,000',
    planC: '60,000'
}, {
    title: 'Compassionate Visitation',
    planA: '10,000',
    planB: '10,000',
    planC: '25,000'
}, {
    title: 'Daily Hospital Income',
    planA: 'N/A',
    planB: '3,000 (RMB100/day)',
    planC: '3,000 (RMB100/day)'
}, {
    title: 'Emergency Assistance Service(incl. Emergency Evacuation & Repatriation, Repatriation of Mortal Remains）',
    planA: '1,000,000',
    planB: '1,000,000',
    planC: '1,000,000'
}, {
    title: 'repatriation of Mortal Remains Limited to',
    planA: '300,000',
    planB: '300,000',
    planC: '300,000'
}, {
    title: 'Funeral Expense Limited to',
    planA: '16,000',
    planB: '16,000',
    planC: '16,000'
}, {
    title: 'Baggage Delay （RMB500 for Every 6 Hours of Delay）',
    planA: 'N/A',
    planB: '1,000',
    planC: '2,000'
}, {
    title: 'Travel Delay （RMB300 for Every 4 Hours of Delay）',
    planA: 'N/A',
    planB: '900',
    planC: '1,800'
}, {
    title: 'Travel change',
    planA: '5,000',
    planB: '10,000',
    planC: '15,000'
}, {
    title: 'Loss of travelers’ credentials',
    planA: '5,000',
    planB: '8,000',
    planC: '10,000'
}, {
    title: 'Credit Card Fraudulent Charges (Not Applicable to Children Under 18 Years)',
    planA: 'N/A',
    planB: '8,000',
    planC: '8,000'
}, {
    title: 'Personal Liability',
    planA: '300,000',
    planB: '300,000 ',
    planC: '800,000 '
}, {
    title: 'Home Care （MAX.RMB1,000 per Item or Set of Items）',
    planA: '5,000',
    planB: '5,000',
    planC: '5,000'
}, {
    title: 'Automatic Extension of Coverage',
    planA: 'Max.10 days',
    planB: 'Max.10 days',
    planC: 'Max.10 days'
},]
const plan1 = [{
    min: 1,
    max: 3,
    value: 90
}, {
    min: 4,
    max: 7,
    value: 248
}, {
    min: 8,
    max: 10,
    value: 288
}, {
    min: 11,
    max: 14,
    value: 345,
}, {
    min: 15,
    max: 17,
    value: 500
}, {
    min: 18,
    max: 21,
    value: 570
}, {
    min: 22,
    max: 24,
    value: 640
}, {
    min: 25,
    max: 28,
    value: 710
}, {
    avg: 154,
    year: 2100
}]
const plan2 = [{
    min: 1,
    max: 3,
    value: 168
}, {
    min: 4,
    max: 7,
    value: 305
}, {
    min: 8,
    max: 10,
    value: 352
}, {
    min: 11,
    max: 14,
    value: 400,
}, {
    min: 15,
    max: 17,
    value: 560
}, {
    min: 18,
    max: 21,
    value: 630
}, {
    min: 22,
    max: 24,
    value: 700
}, {
    min: 25,
    max: 28,
    value: 780
}, {
    avg: 220,
    year: 2800
}]
const plan3 = [{
    min: 1,
    max: 3,
    value: 216
}, {
    min: 4,
    max: 7,
    value: 392
}, {
    min: 8,
    max: 10,
    value: 480
}, {
    min: 11,
    max: 14,
    value: 592,
}, {
    min: 15,
    max: 17,
    value: 870
}, {
    min: 18,
    max: 21,
    value: 1050
}, {
    min: 22,
    max: 24,
    value: 1200
}, {
    min: 25,
    max: 28,
    value: 1350
}, {
    avg: 380,
    year: 4700
}]
const planPremiumTable = {
    1: plan1,
    2: plan2,
    3: plan3
}
const calcPremium = (plan, days) => {
    let sum = 0
    plan = plan % 3 ? plan % 3 : 3;
    const plan1 = planPremiumTable[plan]
    if (days == 'year') {
        sum = plan1[plan1.length - 1].year
    } else if (days > 28) {
        let num = Math.floor(days / 7) + (days % 7 == 0 ? 0 : 1)
        sum = plan1[plan1.length - 2].value + plan1[plan1.length - 1].avg * (num - 4)
    } else {
        const item = plan1.filter(item => {
            return item.min <= days && days <= item.max
        })
        sum = item[0].value
    }
    
    return sum.toFixed(2)
}
const premiumRules = [{
    days: '1-3天',
    plan1: '90元',
    plan2: '168元',
    plan3: '218元'
}, {
    days: '4-7天',
    plan1: '248元',
    plan2: '305元',
    plan3: '392元'
}, {
    days: '8-10天',
    plan1: '288元',
    plan2: '352元',
    plan3: '480元'
}, {
    days: '11-14天',
    plan1: '345元',
    plan2: '400元',
    plan3: '592元'
}, {
    days: '15-17天',
    plan1: '500元',
    plan2: '560元',
    plan3: '870元'
}, {
    days: '18-21天',
    plan1: '570元',
    plan2: '630元',
    plan3: '1050元'
}, {
    days: '22-24天',
    plan1: '640元',
    plan2: '700元',
    plan3: '1200元'
}, {
    days: '25-28天',
    plan1: '710元',
    plan2: '780元',
    plan3: '1350元'
}, {
    days: '每增加一周',
    plan1: '710元+154元*周数',
    plan2: '780元+220元*周数',
    plan3: '1350元+380元*周数'
}, {
    days: '全年保障（每次旅行的保障期限最长为182天）',
    plan1: '2100元',
    plan2: '2800元',
    plan3: '4700元'
},]
const premiumRulesEn = [{
    days: '1-3days',
    plan1: '90 RMB',
    plan2: '168 RMB',
    plan3: '218 RMB'
}, {
    days: '4-7days',
    plan1: '248 RMB',
    plan2: '305 RMB',
    plan3: '392 RMB'
}, {
    days: '8-10days',
    plan1: '288 RMB',
    plan2: '352 RMB',
    plan3: '480 RMB'
}, {
    days: '11-14days',
    plan1: '345 RMB',
    plan2: '400 RMB',
    plan3: '592 RMB'
}, {
    days: '15-17days',
    plan1: '500 RMB',
    plan2: '560 RMB',
    plan3: '870 RMB'
}, {
    days: '18-21days',
    plan1: '570 RMB',
    plan2: '630 RMB',
    plan3: '1050 RMB'
}, {
    days: '22-24days',
    plan1: '640 RMB',
    plan2: '700 RMB',
    plan3: '1200 RMB'
}, {
    days: '25-28days',
    plan1: '710 RMB',
    plan2: '780 RMB',
    plan3: '1350 RMB'
}, {
    days: 'Each Additional week',
    plan1: '710 RMB+154 RMB * No.of Weeks',
    plan2: '780 RMB+220 RMB * No.of Weeks',
    plan3: '1350 RMB+380 RMB * No.of Weeks'
}, {
    days: 'Annual Cover with 182 days per trip max',
    plan1: '2100 RMB',
    plan2: '2800 RMB',
    plan3: '4700 RMB'
},]
const premiumColumns = [{
    title: '保险期间（天）',
    dataIndex: 'days',
    key: 'days'
}, {
    title: '保险计划',
    children: [{
        title: '珍珠计划',
        dataIndex: 'plan1',
        key: 'plan1'
    }, {
        title: '翡翠计划',
        dataIndex: 'plan2',
        key: 'plan2'
    }, {
        title: '铂金计划',
        dataIndex: 'plan3',
        key: 'plan3'
    }]
}]
const premiumColumnsEn = [{
    title: 'Insurance Period（day）',
    dataIndex: 'days',
    key: 'days'
}, {
    title: 'Insurance Plan',
    children: [{
        title: 'Pearl Plan',
        dataIndex: 'plan1',
        key: 'plan1'
    }, {
        title: 'Jade Plan',
        dataIndex: 'plan2',
        key: 'plan2'
    }, {
        title: 'Platinum Plan',
        dataIndex: 'plan3',
        key: 'plan3'
    }]
}];
const columns = [
    {
        title: "智行天下保障责任",
        dataIndex: "title",
        key: "title",
    },
    {
        title: "珍珠计划",
        dataIndex: "planA",
        key: "planA",
    },
    {
        title: "翡翠计划",
        dataIndex: "planB",
        key: "planB",
    },
    {
        title: "铂金计划",
        dataIndex: "planC",
        key: "planC",
    },
];
const columnsEn = [
    {
        title: "Smart Traveler Insurance Plan(B)",
        dataIndex: "title",
        key: "title",
    },
    {
        title: "Pearl Plan",
        dataIndex: "planA",
        key: "planA",
    },
    {
        title: "Jade Plan",
        dataIndex: "planB",
        key: "planB",
    },
    {
        title: "Platinum Plan",
        dataIndex: "planC",
        key: "planC",
    },
];
const planDays = ['1-3', '4-7', '8-10', '11-14', '15-17', '18-21', '25-28'];
const plans = ['智行天下个人境外旅行保险（签证专款）-珍珠计划', '智行天下个人境外旅行保险（签证专款）-翡翠计划',
    '智行天下个人境外旅行保险（签证专款）-铂金计划', '智行天下个人境外旅行保险（签证专款）-全年保障-珍珠计划',
    '智行天下个人境外旅行保险（签证专款）-全年保障-翡翠计划', '智行天下个人境外旅行保险（签证专款）-全年保障-铂金计划'
];
const plansEn = ['Smart Traveler Insurance Plan(B)-Pearl', 'Smart Traveler Insurance Plan(B)-Jade',
    'Smart Traveler Insurance Plan(B)-Platinum', 'Smart Traveler Insurance Plan(B)-Annual-Pearl',
    'Smart Traveler Insurance Plan(B)-Annual-Jade', 'Smart Traveler Insurance Plan(B)-Annual-Platinum'
];

// 阅读文件
const fileList = {
  1: `https://image.ssish.com/static/product/axatp002/file/axatp002_TK.pdf?time=${new Date().getTime()}`, //安盛的保险条款
  2: `https://image.ssish.com/static/product/axatp002/file/axatp002_ZRMC.pdf?time=${new Date().getTime()}`, //安盛的免责声明
  4: `https://image.ssish.com/core/material/20230905153255_宇泰保险经纪（北京）有限公司20230828.pdf`, //客户告知书
}
export {
    plans,
    plansEn,
    columns,
    columnsEn,
    planDays,
    bzqy,
    bzqyEn,
    calcPremium,
    premiumRules,
    premiumRulesEn,
    premiumColumns,
    premiumColumnsEn,
    fileList
}